module.exports = __webpack_public_path__ + "media/start-quest.60bede90.wav";